import Zone from "@insite/client-framework/Components/Zone";
import clearProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearProducts";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page from "@insite/mobius/Page";
import completeLoadYMMD from "@store/Store/Components/RsswYMMD/Handlers/completeLoadYMMD";
import displayProductsYMMD from "@store/Store/Components/RsswYMMD/Handlers/displayProductsYMMD";
import resetParameterYMMD from "@store/Store/Components/RsswYMMD/Handlers/resetParamsYMMD";
import { useProductDataView } from "@store/Store/Components/RsswYMMD/Hooks/useYMMD";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export interface YMMDProductsData {
    productId: string;
    diameter: string | null;
    section: string;
    fit: string | null;
}

export interface ProductsData {
    availableDimensions?: string[];
    productsIds?: YMMDProductsData[];
}

const ProductListYmmdPage = ({ id }: PageProps) => {
    const dispatch = useDispatch();
    const productDataView = useProductDataView();
    const [productsIds, setProductsIds] = useState<string[]>([]);

    useEffect(() => {
        if (productDataView.productsIds?.length > 0) {
            const sortedIds = productDataView.productsIds.map(product => {
                return product.productId;
            });
            setProductsIds(sortedIds);
        } else {
            setProductsIds([]);
        }
    }, [productDataView]);

    useEffect(() => {
        if (productsIds?.length > 0) {
            dispatch(
                displayProductsYMMD({
                    productIds: productsIds,
                    pageSize: productsIds.length,
                }),
            );

            dispatch(resetParameterYMMD());
        } else {
            dispatch(clearProducts());
            dispatch(completeLoadYMMD());
        }
    }, [productsIds]);

    return (
        <Page>
            <Zone contentId={id} zoneName="Content"></Zone>
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: ProductListYmmdPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
